<template>

    <modal name="newsletter-modal" class="dd-m-modal dd-m-modal--auth">
        <button v-on:click="hide()" type="button" class="dd-m-auth__close-btn">
            <i class="dd-m-icon icon-close"></i>
        </button>

        <opt-in-subscribe v-if="step === 1"></opt-in-subscribe>

        <opt-in-subscribe-success v-if="step === 2"></opt-in-subscribe-success>
    </modal>

</template>
<script>
    import OptInSubscribe from "./opt-in-subscribe";
    import OptInSubscribeSuccess from "./opt-in-subscribe-success";

    export default {
        name: 'modal-opt-in',
        components: {OptInSubscribeSuccess, OptInSubscribe},
        mounted() {
            this.subscribe();
            this.display();
        },
        data: () => {
            return {
                step: 1,
            }
        },
        methods: {

            setCountUp() {
                let count = 0;
                const interval = setInterval(() => {
                    count++;
                    if (count === 5) {
                        this.show();
                        clearInterval(interval);
                    }
                }, 1000);
            },

            /**
             * @description
             * Aparece somente uma vez após 2min
             */

            display() {
                if (!localStorage.newsletterHasShown) {
                    localStorage.newsletterHasShown = true;
                    //this.setCountUp();
                }
            },
            subscribe() {
                PubSub.subscribe('openCustomNewsletterModal', (msg, param) => {
                    if (param) {
                        this.step = 1;
                    }
                    this.show();
                });
                PubSub.subscribe('closeCustomNewsletterModal', () => this.hide());
                PubSub.subscribe('updateCustomNewsletterModalStep', (msg, data) => this.goTo(data.step));
                PubSub.subscribe('showNewsletterSuccessModal', () => {
                    this.goTo(2);
                    this.show();
                });
            },
            show() {
                this.$modal.show('newsletter-modal');
            },
            hide() {
                this.step = 1;
                this.$modal.hide('newsletter-modal');
            },
            goTo(step) {
                this.step = step;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/opt-in/modal-opt-in.vue